import styles from "../Filters.module.scss";
import { h } from "preact";
import { Text } from "preact-i18n";
import { FilterItemProps } from "components/Filters/Filters";
import FilterWithLabel from "components/Filters/FilterWithLabel/FilterWIthLabel";

interface FilterCheckboxesProps extends FilterItemProps<string[]> {
    options: { value: string; labelId: string }[];
    stacked?: boolean;
}

const FilterCheckboxes = (props: FilterCheckboxesProps) => {
    const {
        addressId,
        fieldName,
        options,
        value = [],
        onChange,
        stacked = false,
    } = props;

    const handleCheckChange = (optionValue: string, checked: boolean) => {
        if (onChange) {
            const tmpValue = [...value];
            if (checked) {
                if (!tmpValue.includes(optionValue)) {
                    tmpValue.push(optionValue);
                }
            } else {
                if (tmpValue.includes(optionValue)) {
                    tmpValue.splice(tmpValue.indexOf(optionValue), 1);
                }
            }
            onChange(tmpValue);
        }
    };

    return (
        <FilterWithLabel {...props}>
            <div
                className={
                    styles.checkboxes + " " + (stacked ? styles.stacked : null)
                }
            >
                {options.map((option) => (
                    <label
                        htmlFor={`${fieldName}-${addressId}-${option.value}`}
                    >
                        <input
                            type="checkbox"
                            id={`${fieldName}-${addressId}-${option.value}`}
                            name={`${fieldName}-${addressId}`}
                            checked={value.includes(option.value)}
                            onChange={(e) => {
                                handleCheckChange(
                                    option.value,
                                    (e.target as HTMLInputElement).checked,
                                );
                            }}
                        />
                        <span>
                            <Text id={option.labelId} />
                        </span>
                    </label>
                ))}
            </div>
        </FilterWithLabel>
    );
};

export default FilterCheckboxes;
